// extracted by mini-css-extract-plugin
export default {"preLoader":"App_preLoader__Om5Ez","hidePreLogo":"App_hidePreLogo__1JoDv","upscaleImage":"App_upscaleImage__nbQ2x"};